export enum TagsManagerGridEvents {
  OnTagNameClick = 'tagsManagerGridTagNameClick',

  OnAddTag = 'tagsManagerGridAddTag',
  OnDeleteTag = 'tagsManagerGridDeleteTag',
  OnDeleteTagFromInlineButton = 'tagsManagerGridInlineDeleteTag',
  OnCloneTag = 'tagsManagerGridCloneTag',
}

export class OnTagNameClick extends CustomEvent<{ tagId: string; tagName: string }> {
  constructor(tagId: string, tagName: string) {
    super(TagsManagerGridEvents.OnTagNameClick, {
      detail: {
        tagId,
        tagName,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnAddTag extends CustomEvent<{}> {
  constructor() {
    super(TagsManagerGridEvents.OnAddTag, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnDeleteTag extends CustomEvent<{
  gzTagIds: Array<{ _id: string }>;
  selectAllEnabled: boolean;
  expectedCount: number;
}> {
  constructor(gzTagIds: Array<{ _id: string }>, selectAllEnabled: boolean, expectedCount: number) {
    super(TagsManagerGridEvents.OnDeleteTag, {
      detail: {
        gzTagIds,
        selectAllEnabled,
        expectedCount,
      },
      bubbles: true,
      composed: true,
    });
  }
}
